module.exports = __webpack_public_path__ + "static/media/non_ulip.43f0be5e.mp3";